import ComponentBase from 'components/_base/ComponentBase';
import jQuery from 'jquery';

export default ComponentBase.extend({
	template: require('./directionsMobileCTA.hbs'),
	events: {
		click: 'onClickDirectionsCTA'
	},
	active: false,
	constructor(options) {
		this.componentClass = options.componentClass;
		ComponentBase.prototype.constructor.call(this, options);
	},
	initialize(options) {
		ComponentBase.prototype.initialize.call(this, options);
		this.listenTo(this.widget.bus, 'directions_btn_event', active => {
			this.active = active;
			if (this.active) {
				jQuery(this.el).addClass('active');
			} else {
				jQuery(this.el).removeClass('active');
			}
		});
	},
	onClickDirectionsCTA() {
		this.active = !this.active;
		this.bus.trigger('directions_btn_event', this.active);
	}
});



// WEBPACK FOOTER //
// ./src/components/directionsMobileCTA/DirectionsMobileCTA.js